import React from 'react';
import _sortBy from 'lodash/sortBy';

import { Divider, Link, Menu, MenuItem, ListItemText, ListItemIcon } from '@mui/material';

const APP_SETTINGS = {
  Aware: {
    icon: 'app-icon-aware.png',
    sortOrder: 1
  },
  Strive: {
    icon: 'app-icon-strive.png',
    sortOrder: 2
  },
  Forethought: {
    icon: 'app-icon-forethought.png',
    sortOrder: 3
  },
  Formspace: {
    icon: 'app-icon-formspace.png',
    sortOrder: 4
  },
  'Facilities&Events': {
    icon: 'app-icon-facilities-events.png',
    sortOrder: 5
  },
  Helpdesk: {
    icon: 'app-icon-helpdesk.png',
    sortOrder: 6
  },
  Management: {
    icon: 'app-icon-management.png',
    sortOrder: 7
  },
  Beacon: {
    icon: 'app-icon-beacon.png',
    sortOrder: 8
  },
  SchoolObjects: {
    icon: 'app-icon-SchoolObjects.png',
    sortOrder: 9
  }
};

export const getIconPath = app =>
  `/eduphoria_webcontrols/assets/img/logos/${APP_SETTINGS[app]?.icon || 'app-icon-SchoolObjects.png'}`;

const AppSwitcherMenuListItem = ({ iconSrc, name, path, selected }) => {
  return (
    <MenuItem component={Link} href={`${path}`} selected={selected}>
      <ListItemIcon sx={{ width: 24, height: 24 }}>
        <img src={iconSrc} alt={`${name} icon`} />
      </ListItemIcon>
      <ListItemText>{name}</ListItemText>
    </MenuItem>
  );
};

const AppSwitcherMenu = ({
  anchorEl,
  applicationName,
  closeMenu,
  licensedApplications
}) => {
  return (
    <Menu
      id="utility-bar-application-switcher"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={closeMenu}
      variant="menu"
    >
      {[
        ..._sortBy(
          licensedApplications,
          ({ name }) => APP_SETTINGS[name]?.sortOrder || 1000
        ).map(({ name, path }) => {
          return (
            <AppSwitcherMenuListItem
              key={name}
              iconSrc={getIconPath(name)}
              name={name}
              path={path}
              selected={name === applicationName}
            />
          );
        }),
        <Divider key="app-switcher-menu-divider" />,
        <AppSwitcherMenuListItem
          key="Applications Home"
          iconSrc="/eduphoria_webcontrols/assets/img/home.png"
          name="Applications Home"
          path="/eduphoria_webcontrols/Applications.aspx"
        />
      ]}
    </Menu>
  );
};

export default AppSwitcherMenu;
